// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonPlaceholders = {
  enter: "入力してください",
  select: "選択してください",
} as const;
